import { plain } from './Plain';
import { GridTemplateInputToken } from './types';

/**
 * Convert string and CssFunction arrays into a plain CssFunction array
 * @param tokens The tokens describing the template to be calculated by the grid
 */
export function normalizeTokens(tokens: GridTemplateInputToken[] = []) {
  return tokens.map((x) => (typeof x === 'string' || typeof x === 'number' ? plain(x) : x));
}
